<div class="treetable-container" #treeTableContainer>
    @if (ready) {
        <ejs-treegrid
            #treegrid
            [dataSource]="config.data"
            [treeColumnIndex]="config.rowButtonsFirst ? 1 : 0"
            [idMapping]="config.idProperty"
            [childMapping]="config.childProperty"
            [height]="scrollHeight"
            [rowHeight]="rowHeight"
            [allowReordering]="config.allowReordering"
            [allowResizing]="true"
            [allowFiltering]="true"
            [allowSorting]="true"
            [showColumnMenu]="true"
            [enableCollapseAll]="true"
            [enableHover]="true"
            [filterSettings]="filterSettings"
            [editSettings]="editSettings"
            (queryCellInfo)="queryCellInfo($event)"
            (click)="click($event)"
            (actionComplete)="actionCompleted($event)"
        >
            <e-columns>
                @if (config.rowButtonsFirst && config.rowButtons) {
                    <e-column
                        headerText="Actions"
                        textAlign="Center"
                        [allowEditing]="false"
                        [allowResizing]="false"
                        [width]="config.rowButtons.length * 40"
                    >
                        <ng-template #template let-data>
                            @for (btn of config.rowButtons; track btn) {
                                <i
                                    [class]="'cellbtn ' + btn.icon"
                                    [title]="btn.tooltip"
                                    (click)="btn.clickEvent(data)"
                                    [attr.data-uiid]="btn.dataUiid"
                                ></i>
                            }
                        </ng-template>
                    </e-column>
                }
                @for (col of columns; track col.fieldName) {
                    <e-column
                        [field]="col.fieldName"
                        [headerText]="col.prettyName"
                        [edit]="col.editOptions"
                        [editType]="col.editType"
                        [format]="col.formatOptions"
                        [displayAsCheckBox]="col.displayAsCheckBox"
                        [width]="col.columnWidth"
                        [freeze]="col.freezeDirection"
                        [allowEditing]="!col.readonly"
                        [visible]="col.visible"
                    >
                    </e-column>
                }
                @if (!config.rowButtonsFirst && config.rowButtons) {
                    <e-column
                        headerText="Actions"
                        textAlign="Center"
                        [allowEditing]="false"
                        [allowResizing]="false"
                        [width]="config.rowButtons.length * 40"
                    >
                        <ng-template #template let-data>
                            @for (btn of config.rowButtons; track btn) {
                                <i
                                    [class]="'cellbtn ' + btn.icon"
                                    [title]="btn.tooltip"
                                    (click)="btn.clickEvent(data)"
                                    [attr.data-uiid]="btn.dataUiid"
                                ></i>
                            }
                        </ng-template>
                    </e-column>
                }
            </e-columns>
        </ejs-treegrid>
    }
</div>
